var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.62435 11.5001H14.3743M11.4993 14.3751V8.62508M21.0827 11.5001C21.0827 16.7928 16.7921 21.0834 11.4993 21.0834C6.20662 21.0834 1.91602 16.7928 1.91602 11.5001C1.91602 6.20735 6.20662 1.91675 11.4993 1.91675C16.7921 1.91675 21.0827 6.20735 21.0827 11.5001Z",
    stroke: "#F6F6F6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.40d490d93399a19148602dc4622e1015.svg";
export { ForwardRef as ReactComponent };